import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Header from '../containers/Header';
import * as shapes from '../shapes';
import WebReaderLoader from '../../customer/tipping/components/WebReaderLoader';
import { getIsProcessorMode } from '../webReader/selector';
import { withPaymentInfoSetupStatus } from '../../common/hoc/paymentInfoSetupStatus';
import SetupPaymentInfoModal from '../../common/SetupPaymentInfoModal';
import withToggle from '../../common/hoc/withToggle';

const Layout = ({ children, isProcessorMode, setupPaymentInfoModalIsOn, setupPaymentInfoModalOff }) => (
  <div className="o-page-height o-flexbox o-flexbox--column">
    <Header />
    { children }
    <WebReaderLoader display-if={!isProcessorMode} />
    <SetupPaymentInfoModal
      isOpen={setupPaymentInfoModalIsOn}
      onClose={setupPaymentInfoModalOff}
      restrictFullPage
    />
  </div>
);

Layout.propTypes = {
  children: shapes.children.isRequired,
  isProcessorMode: shapes.flag.isRequired,
  setupPaymentInfoModalIsOn: PropTypes.bool.isRequired,
  setupPaymentInfoModalOff: PropTypes.func.isRequired,
};

export default compose(
  withPaymentInfoSetupStatus,
  withToggle('setupPaymentInfoModal', props => !props.isPaymentInfoSetup),
  connect(state => ({
    isProcessorMode: getIsProcessorMode(state),
  })
))(Layout);
